export const getEmailThemePayload = ({ colors, footerImage, textStyles, linkColor, language }) => {
  const form = new FormData()

  form.append('background_color', colors.backgroundColor)
  form.append('content_background_color', colors.contentBackgroundColor)
  form.append('header_background_color', colors.headerBackgroundColor)
  form.append('footer_background_color', colors.footerBackgroundColor)

  if (footerImage) {
    form.append('footer_image', footerImage)
  }

  form.append('h1_font_family', textStyles.header1.fontFamily)
  form.append('h1_font_size', textStyles.header1.fontSize)
  form.append('h1_is_bold', textStyles.header1.bold)
  form.append('h1_is_italic', textStyles.header1.italic)
  form.append('h1_color', textStyles.header1.color)

  form.append('h2_font_family', textStyles.header2.fontFamily)
  form.append('h2_font_size', textStyles.header2.fontSize)
  form.append('h2_is_bold', textStyles.header2.bold)
  form.append('h2_is_italic', textStyles.header2.italic)
  form.append('h2_color', textStyles.header2.color)

  form.append('h3_font_family', textStyles.header3.fontFamily)
  form.append('h3_font_size', textStyles.header3.fontSize)
  form.append('h3_is_bold', textStyles.header3.bold)
  form.append('h3_is_italic', textStyles.header3.italic)
  form.append('h3_color', textStyles.header3.color)

  form.append('body_font_family', textStyles.body.fontFamily)
  form.append('body_font_size', textStyles.body.fontSize)
  form.append('body_color', textStyles.body.color)
  form.append('body_is_bold', textStyles.body.bold)
  form.append('body_is_italic', textStyles.body.italic)

  form.append('link_color', linkColor)

  form.append('language', language)

  return form
}

export const getColors = (savedColors, defaultColors) => ({
  backgroundColor: savedColors.backgroundColor || defaultColors.backgroundColor,
  contentBackgroundColor: savedColors.contentBackgroundColor || defaultColors.contentBackgroundColor,
  headerBackgroundColor: savedColors.headerBackgroundColor || defaultColors.headerBackgroundColor,
  footerBackgroundColor: savedColors.footerBackgroundColor || defaultColors.footerBackgroundColor,
})

export const getTextStyles = (savedTextStyles, defaultTextStyles) => ({
  header1: {
    fontFamily: savedTextStyles.header1.fontFamily || defaultTextStyles.header1.fontFamily,
    fontSize: savedTextStyles.header1.fontSize || defaultTextStyles.header1.fontSize,
    bold: savedTextStyles.header1.bold ?? defaultTextStyles.header1.bold,
    italic: savedTextStyles.header1.italic ?? defaultTextStyles.header1.italic,
    color: savedTextStyles.header1.color || defaultTextStyles.header1.color,
  },
  header2: {
    fontFamily: savedTextStyles.header2.fontFamily || defaultTextStyles.header2.fontFamily,
    fontSize: savedTextStyles.header2.fontSize || defaultTextStyles.header2.fontSize,
    bold: savedTextStyles.header2.bold ?? defaultTextStyles.header2.bold,
    italic: savedTextStyles.header2.italic ?? defaultTextStyles.header2.italic,
    color: savedTextStyles.header2.color || defaultTextStyles.header2.color,
  },
  header3: {
    fontFamily: savedTextStyles.header3.fontFamily || defaultTextStyles.header3.fontFamily,
    fontSize: savedTextStyles.header3.fontSize || defaultTextStyles.header3.fontSize,
    bold: savedTextStyles.header3.bold ?? defaultTextStyles.header3.bold,
    italic: savedTextStyles.header3.italic ?? defaultTextStyles.header3.italic,
    color: savedTextStyles.header3.color || defaultTextStyles.header3.color,
  },
  body: {
    fontFamily: savedTextStyles.body.fontFamily || defaultTextStyles.body.fontFamily,
    fontSize: savedTextStyles.body.fontSize || defaultTextStyles.body.fontSize,
    bold: savedTextStyles.body.bold ?? defaultTextStyles.body.bold,
    italic: savedTextStyles.body.italic ?? defaultTextStyles.body.italic,
    color: savedTextStyles.body.color || defaultTextStyles.body.color,
  },
})

export const parseEmailThemeData = data => ({
  colors: {
    backgroundColor: data.background_color,
    contentBackgroundColor: data.content_background_color,
    headerBackgroundColor: data.header_background_color,
    footerBackgroundColor: data.footer_background_color,
  },
  footerImage: data.footer_image,
  textStyles: {
    header1: {
      fontFamily: data.h1_font_family,
      fontSize: data.h1_font_size,
      bold: data.h1_is_bold,
      italic: data.h1_is_italic,
      color: data.h1_color,
    },
    header2: {
      fontFamily: data.h2_font_family,
      fontSize: data.h2_font_size,
      bold: data.h2_is_bold,
      italic: data.h2_is_italic,
      color: data.h2_color,
    },
    header3: {
      fontFamily: data.h3_font_family,
      fontSize: data.h3_font_size,
      bold: data.h3_is_bold,
      italic: data.h3_is_italic,
      color: data.h3_color,
    },
    body: {
      fontFamily: data.body_font_family,
      fontSize: data.body_font_size,
      bold: data.body_is_bold,
      italic: data.body_is_italic,
      color: data.body_color,
    },
  },
  linkColor: data.link_color,
})
